import { finishProgressAttempt, isCurrentProgressAttempt } from '../systems/ProgressData';
import Phaser from 'phaser';
import { GAME_MODE, getGameMode } from '../systems/GameMode';
import { mountMenu, element, button, header, modeBadge, rows, go, primaryShortcut } from '../util/menuUI';

function formatDuration(durationMs) {
  const seconds = Math.max(0, Math.round(durationMs / 1000));
  const minutes = Math.floor(seconds / 60);
  const remaining = String(seconds % 60).padStart(2, '0');
  return minutes ? `${minutes} min ${remaining} s` : `${seconds} s`;
}

export class PracticeResultScene extends Phaser.Scene {
  constructor() {
    super('PracticeResultScene');
  }

  create(run = {}) {
    if (!isCurrentProgressAttempt(run.progressAttemptId)) return;
    if (getGameMode(this.registry) !== GAME_MODE.PRACTICE) {
      this.scene.start('ResultScene', run);
      return;
    }

    const planetId = this.registry.get('currentPlanet') || 'suma';
    if (!run.devPreview) finishProgressAttempt({ planetId, missionIndex: this.registry.get('currentMissionData')?.index ?? 0, run, mode: 'practice' });
    const root = mountMenu(this);
    root.classList.add(
      planetId === 'resta' ? 'tmag-result-resta'
        : planetId === 'mult' ? 'tmag-result-mult'
          : planetId === 'division' ? 'tmag-result-division'
            : 'tmag-result-suma',
    );
    if (planetId === 'resta') root.classList.add('tmag-resta');
    if (planetId === 'mult') root.classList.add('tmag-multiplicacion');
    if (planetId === 'division') root.classList.add('tmag-division');

    const mapScene = planetId === 'resta'
      ? 'RestaMissionsScene'
      : planetId === 'mult'
        ? 'MultiplicacionMissionsScene'
        : planetId === 'division'
          ? 'DivisionMissionsScene'
          : 'SumaMissionsScene';

    const menuHeader = header(
      root,
      '¡PRÁCTICA COMPLETADA!',
      `${run.missionName || 'Planeta'} · ${run.missionSkill || ''}`,
      '← SISTEMA',
      () => go(this, mapScene),
    );
    menuHeader.append(modeBadge(this));

    const panel = element('div', 'tmag-detail tmag-practice-result');
    rows(panel, [
      ['Ejercicios realizados', run.completed || 0],
      ['Cantidad completada', `${run.completed || 0} / ${run.total || 0}`],
      ['Correctas', run.correct || 0],
      ['Incorrectas', run.wrong || 0],
      ['Duración total', formatDuration(run.durationMs)],
    ]);

    const repeat = () => go(this, 'PracticeScene');
    panel.append(button('↻ REPETIR PRÁCTICA', repeat, 'tmag-button tmag-primary'));
    panel.append(button('← VOLVER AL SISTEMA', () => go(this, mapScene), 'tmag-button'));
    root.append(panel);
    primaryShortcut(root, repeat);
  }
}
